export const MODAL_MESSAGES = {
  NO_TEXT_TO_COPY: "No hay texto para copiar",
  CLIPBOARD_API_UNAVAILABLE: "La API de portapapeles no está disponible",
  URL_COPY_SUCCESS: "URL copiada al portapapeles",
  URL_COPY_ERROR: "Error al copiar la URL",
};
